import React, {Component} from  "react";
import {Row, Col, Tabs, Input, Spin, Divider } from 'antd';
import {connect} from 'react-redux';
// import cookie from "react-cookies";
import { getVerticalBrushPanel, getC240CanvasComponent, getStainChooser, getSpeedPanel, getBmaPanel } from "../c240_slot_component_utils";
import { scanTypeVals } from '../../../utils/const';
import { scanSpeed } from "../slots";
import { getBarcodeCrop} from '../c240_preview_utils';
import { updateCountSlotWise } from '../../../action/bloodConfig.action';


const { TabPane } = Tabs;

class GeneralPreviewSettingsComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            specimenTypes:[],
        }
    }

    componentDidMount = () => {
        let specimens_=[]
        if((((this.props.deviceStatus || {}).scanner_health || {}).scanner_response||{}).supportedSpecimenTypes){
            (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response||{}).supportedSpecimenTypes.map((index)=>{
                specimens_.push(index);
            })
        }
        this.setState({
            specimenTypes: specimens_,
        })

    }

    setWBCCount = (count) => {
        this.props.onWBCCountChange(count);
        // this.props.dispatch(updateCountSlotWise([this.props.id, count]));
    }

    changeScanType = (key) => {
        this.props.onScanTypeChange(key);
    }

    fetchWSIdetails = () => {
        return <Col>{
            (this.props.scan_speed === scanSpeed.FAST) ? 
                <div className="arial-font" style={{fontSize: "13px"}}>
                    <Row>
                    <span>Fast scanning.</span> 
                    </Row>
                    <Row>
                        <span>Suitable for evenly cut tissue sections without artifacts.</span> 
                    </Row>
                </div> :
            (this.props.scan_speed === scanSpeed.MEDIUM) ? 
                <div className="arial-font" style={{fontSize: "13px"}}>
                    <Row>
                    <span>1.5x slower but safer mode of scanning. <b> Suitable for</b></span> 
                    </Row>
                    <Row>
                        <span> ○  Evenly cut tissue sections with few folds</span> 
                    </Row>
                    <Row>
                        <span> ○  PAP slides</span> 
                    </Row>
                    <Row>
                        <span> ○  Cytology smears without very thick areas</span> 
                    </Row>
                    <Row>
                        <span> ○  Old slides with air/dpx bubbles</span> 
                    </Row>
                </div> :
                <div className="arial-font" style={{fontSize: "13px"}}>
                    <Row>
                    <span>3x slower but very safe mode of scanning. <b> Suitable for</b></span> 
                    </Row>
                    <Row>
                        <span> ○ Tissue slides with heavy folds / dirt under cover slip / unevenly cut tissue sections</span> 
                    </Row>
                    <Row>
                        <span> ○ Cytology smears with thick sections</span> 
                    </Row>
                    <Row>
                        <span> ○ All things crazy!</span> 
                    </Row>
                </div>
                }
        </Col>
    }
    

    render() {
        const slideKey = this.props.cassetteKey + "S" + this.props.id;
        // let is_superuser = cookie.loadAll().superuser === "true";
        let trayKey = this.props.cassetteKey;
        let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        let tray = parseInt(trayKey.split("T")[1]);
        const previewCameraBarcodeUrl = getBarcodeCrop(this.props.id + 1, tray, rack) ;

        let deviceType = (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response|| {})['deviceType']
        let isHemoLens = deviceType && deviceType.includes("HEMOLENS");

        return(
            <div>
                <Row style={{height: '100%'}}>
                    <Col span={24}>
                        <Row>
                            {getC240CanvasComponent(this.props.status, this.props.previewCanvasRef, this.props.thresholdCanvasRef,
                                this.props.brushEraserPrevCanvasRef, this.props.regions, this.props.onCanvasUpdate, this.props.allowPainting, this.props.startPainting, this.props.paintCanvas, 
                                this.props.stopPainting, this.props.dropDistanceCanvas, this.props.dropDistanceCanvasRef, this.props.focusPointsCanvas, 
                                this.props.focusPointsCanvasRef, this.props.preview, this.props.device_id, this.props.brushType,
                                this.props.showBrushOrEraserSize, rack, tray, this.props.id, this.props.slideType)}
                        </Row>
                        {console.log("Selected Area",this.props.regionArea,"mm2")}
                        {/* <Row>
                            <Col className="selected-area-component">
                                Selected Area : {this.props.regionArea} mm2
                            </Col>
                        </Row> */}
                    </Col>
                </Row>
                <Row style={{margin: "0px 25px", marginTop: "5px"}}> 
                    <Col span={5} className="side-panel-section" style= {{paddingTop: "12px"}}>
                        <Col>
                            <Row className="arial-font" style={{marginRight:10,fontSize:13}}><b>Slide Name</b></Row>
                            <Divider></Divider>
                            <Spin spinning={this.props.reading_barcode} tip="Trying to Read Barcode...">
                                <Input value={this.props.name} style={{width: 260, marginTop:"10px"}} onChange={this.props.onScanNameChange} />
                            </Spin>
                            <br></br>
                            <span className="arial-font" style={{marginRight:10, fontSize:13}}><b>Label / Barcode Image</b></span>
                            <Divider></Divider>
                            <Col style={{ transform: "rotate(-90deg)", width:"5vw", marginLeft:"10px"}}>
                            <img className="horizontal-barcode-image" alt="Barcode" src={previewCameraBarcodeUrl} />
                            </Col>
                        </Col>
                    </Col>
                    <Col span={5} offset={3} style= {{paddingTop: "12px"}} >
                        <Row className="side-panel-section">
                            <Col>
                                {getStainChooser(this.props.onSpecimenTypeChange, this.props.preview, this.state.specimenTypes, this.props.specimen_type)}
                            </Col>
                        </Row>
                        <Row className="side-panel-section">
                            <Col >
                                <span className="arial-font" style={{marginRight:10, fontSize:13}}><b>Edit Area Selection</b></span>                                                        
                                {getVerticalBrushPanel(this.props.brushType, this.props.brushSize, this.props.changeBrushType, this.props.movedBrushSizeSlider)}
                            </Col>
                        </Row>
                    </Col>

                    
                    <Col span={8} offset={2}>
                        <Row className="side-panel-section">
                            <Tabs activeKey={this.props.scan_type} onChange={this.changeScanType} size="small">
                                <TabPane tab="WSI" key={scanTypeVals.WSI}>
                                    {getSpeedPanel(this.props.onScanSpeedChange, this.props.preview, this.props.scan_speed)}
                                    {this.fetchWSIdetails()}
                                </TabPane>
                                <TabPane tab="Z SCAN" key={scanTypeVals.Z_STACK}>
                                    <Row style={{fontSize:13}} className="arial-font"><b>Multiple focal planes are captured for each field of view.</b></Row>
                                    <Row style={{fontSize:13}} className="arial-font">Creates an interface similar to manual fine focus at every point in the stitched scan using mouse-scroll wheel</Row>  
                                    <Row key={0} style={{ padding: 10 }}>
                                        <Row style={{fontSize:13}}>
                                            <Col span={10} className="z-stack-scan-text">
                                                Z Stack Levels
                                            </Col>
                                            <Col span={14}>
                                                <Input className="z-stack-scan-input-field" value={this.props.zstack_level} 
                                                    placeholder={10} onChange={this.props.onZLevelsChange} />
                                            </Col>
                                        </Row>
                                        <Row style={{fontSize:13}}>
                                            <Col span={10} className="z-stack-scan-text">
                                                Step Size (um)
                                            </Col>
                                            <Col span={14}>
                                                <Input className="z-stack-scan-input-field" value={this.props.zstack_step} 
                                                    placeholder={0.5} onChange={this.props.onStepSizeChange} />
                                            </Col>
                                        </Row>
                                    </Row>
                                    <Row style={{fontSize:13}} className="arial-font"><b>Ideal for</b></Row> 
                                    <Row style={{fontSize:13}} className="arial-font">1. Slides with over lapping cells ex. FNACs</Row> 
                                    <Row style={{fontSize:13}} className="arial-font">2. Thick tissue sections / sections with lots of folds</Row>
                                </TabPane>
                                {this.props.specimen_type === "BM"?
                                    <TabPane tab="FIELDS" key={scanTypeVals.BLOOD}>
                                        {getBmaPanel(isHemoLens, this.props.wbcCount, this.setWBCCount) }
                                    </TabPane>
                                    : null}
                            </Tabs>
                        </Row>
                    </Col>
                    {/* <Col span={8} style={{marginTop:"40px"}}>
                        
                        <Col >                        
                            {getVerticalBrushPanel(this.props.brushType, this.props.brushSize, this.props.changeBrushType, this.props.movedBrushSizeSlider)}
                        </Col>
                        
                    </Col> */}
                    {/* <Col span={8} style={{marginTop:"12px"}}>
                        <Row className="side-panel-section" style={{marginBottom:8}}>
                            <Col>
                                <span className="arial-font" style={{marginRight:10, fontSize:13}}><b>Slide Name</b></span>
                                <Spin spinning={this.props.reading_barcode} tip="Trying to Read Barcode...">
                                    <Input value={this.props.name}
                                        style={{width: 260}} onChange={this.props.onScanNameChange} />
                                </Spin>
                            </Col>
                        </Row>
                        <Row className="side-panel-section" style={{marginBottom:8}}>
                            <Col>
                                {getStainChooser(this.props.onSpecimenTypeChange, this.props.preview, this.props.specimen_type)}
                            </Col>
                        </Row> */}
                        {/* {is_superuser ?
                            <Row className="side-panel-section">
                                <Col span={24}>
                                    <br></br>
                                    <Row style={{fontSize:13}}>
                                        <Col span={24}>
                                            <Checkbox checked={this.props.preview.doTilingOnly} onChange={this.props.toggleTiling}>
                                                Do Tiling Only
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                    <Row style={{fontSize:13}}>
                                        <Col span={24}>
                                            <Checkbox checked={this.props.preview.doTilingAfterScan} onChange={this.props.toggleTilingAfterScan}>
                                                Do Tiling After Scan
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row> :
                            null
                        } */}
                    {/* </Col> */}
                </Row>
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        deviceStatus: state.deviceStatusReducer[ownProps.device_id]
    }
}

export default connect(mapStateToProps)(GeneralPreviewSettingsComp);